var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlackColorized = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.374,
  height: 7.583,
  x: 8.417,
  fill: "#4DAA78",
  rx: 1.687
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 7.583,
  height: 3.374,
  x: 8.417,
  y: 8.417,
  fill: "#E5B145",
  rx: 1.687
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 7.583,
  height: 3.374,
  y: 4.209,
  fill: "#60AFDA",
  rx: 1.687
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#60AFDA",
  d: "M4.209 1.687a1.687 1.687 0 0 1 3.374 0v1.687H5.896a1.687 1.687 0 0 1-1.687-1.687z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4DAA78",
  d: "M12.626 5.896a1.687 1.687 0 1 1 1.687 1.687h-1.687V5.896z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1316A",
  d: "M0 10.104c0-.931.755-1.687 1.687-1.687h1.687v1.687a1.687 1.687 0 1 1-3.374 0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5B145",
  d: "M8.417 12.626h1.687a1.687 1.687 0 1 1-1.687 1.687v-1.687z"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3.374,
  height: 7.583,
  x: 4.209,
  y: 8.417,
  fill: "#C1316A",
  rx: 1.687
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlackColorized);
export default ForwardRef;